// consts
import {
  ACCOUNT_UUID, DIMENSIONS,
  FORMAT, FREQUENCY, INTERNAL_DIMENSIONS,
  INTERNAL_METRICS, INTERVAL_DIMENSION,
  IS_SCHEDULED,
  METRICS, MONETIZATION_METRICS, PERFORMANCE_METRICS,
  PREBID_METRICS, PREBID_MONETIZATION_METRICS, PREBID_VIDEO_METRICS,
  REPORT_CREATED, REPORT_UUID,
  SCHEDULE, STANDARD_DIMENSION
} from "../../monetizationform/consts";


export const getSavePayload = (formValues, accountUUID, sitesAndAppsUUIDs) => {
  const payload = {...formValues}

  if (!payload[ACCOUNT_UUID]) payload[ACCOUNT_UUID] = accountUUID
  payload[METRICS] = [...payload[METRICS]]
  payload[DIMENSIONS] = [...payload[DIMENSIONS]]
  delete payload[STANDARD_DIMENSION]
  delete payload[INTERVAL_DIMENSION]
  delete payload[PERFORMANCE_METRICS]
  delete payload[MONETIZATION_METRICS]
  delete payload[PREBID_VIDEO_METRICS]
  delete payload[PREBID_MONETIZATION_METRICS]
  delete payload[REPORT_CREATED]

  // Collapse all-sites selection into ALL sentinel
  const siteFilters = payload.filters?.SITE || [];
  const totalSites = Object.keys(sitesAndAppsUUIDs || {}).length;
  if (totalSites > 0 && siteFilters.length >= totalSites) {
    payload.filters = {...payload.filters, SITE: ["ALL"]}
  }
  delete payload.allSitesSelected

  // hold on to this value
  const scheduleFormat = payload[SCHEDULE][FORMAT]
  if (!payload[IS_SCHEDULED]) {
    delete payload[SCHEDULE]
    payload[SCHEDULE] = {}
    payload[SCHEDULE][FREQUENCY] = 'ONCE';
    payload[SCHEDULE][FORMAT] = scheduleFormat;
  }

  return payload
}

export const getPreviewPayload = (formValues, accountUUID, format) => {
  const payload = {...formValues}
  payload[ACCOUNT_UUID] = accountUUID
  payload[METRICS] = [...payload[METRICS]]
  payload[DIMENSIONS] = [...payload[DIMENSIONS]]
  delete payload[INTERNAL_METRICS]
  delete payload[STANDARD_DIMENSION]
  delete payload[INTERVAL_DIMENSION]
  delete payload[PERFORMANCE_METRICS]
  delete payload[MONETIZATION_METRICS]
  delete payload[PREBID_VIDEO_METRICS]
  delete payload[PREBID_MONETIZATION_METRICS]
  delete payload[REPORT_CREATED]

  delete payload[SCHEDULE]
  payload[SCHEDULE] = {}
  payload[SCHEDULE][FREQUENCY] = 'ONCE'
  payload[SCHEDULE][FORMAT] = format

  delete payload[REPORT_UUID]
  return payload
}